import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import DateConstants from './DateConstants';
import { getTitleString, getTodayTime } from '../util/';
import { prefix } from "../../../../wui-core/src/index.js";

function isSameDay(one, two) {
  return one && two && one.isSame(two, 'day');
}

function beforeCurrentMonthYear(current, today) {
  if (current.year() < today.year()) {
    return 1;
  }

  return current.year() === today.year() && current.month() < today.month();
}

function afterCurrentMonthYear(current, today) {
  if (current.year() > today.year()) {
    return 1;
  }

  return current.year() === today.year() && current.month() > today.month();
}

function getIdFromDate(date) {
  return "".concat(prefix, "-date-calendar-").concat(date.year(), "-").concat(date.month(), "-").concat(date.date());
}

var DateTBody = /*#__PURE__*/function (_React$Component) {
  _inherits(DateTBody, _React$Component);

  var _super = _createSuper(DateTBody);

  function DateTBody() {
    _classCallCheck(this, DateTBody);

    return _super.apply(this, arguments);
  }

  _createClass(DateTBody, [{
    key: "render",
    value: function render() {
      var props = this.props;
      var contentRender = props.contentRender,
          prefixCls = props.prefixCls,
          selectedValue = props.selectedValue,
          value = props.value,
          showWeekNumber = props.showWeekNumber,
          dateRender = props.dateRender,
          disabledDate = props.disabledDate,
          hoverValue = props.hoverValue,
          onSelect = props.onSelect;
      var iIndex;
      var jIndex;
      var current;
      var dateTable = [];
      var today = getTodayTime(value);
      var cellClass = "".concat(prefixCls, "-cell");
      var weekNumberCellClass = "".concat(prefixCls, "-week-number-cell");
      var dateClass = "".concat(prefixCls, "-date");
      var todayClass = "".concat(prefixCls, "-today");
      var selectedClass = "".concat(prefixCls, "-selected-day");
      var selectedDateClass = "".concat(prefixCls, "-selected-date"); // do not move with mouse operation

      var selectedStartDateClass = "".concat(prefixCls, "-selected-start-date");
      var selectedEndDateClass = "".concat(prefixCls, "-selected-end-date");
      var inRangeClass = "".concat(prefixCls, "-in-range-cell");
      var lastMonthDayClass = "".concat(prefixCls, "-last-month-cell");
      var nextMonthDayClass = "".concat(prefixCls, "-next-month-btn-day");
      var disabledClass = "".concat(prefixCls, "-disabled-cell");
      var firstDisableClass = "".concat(prefixCls, "-disabled-cell-first-of-row");
      var lastDisableClass = "".concat(prefixCls, "-disabled-cell-last-of-row");
      var lastDayOfMonthClass = "".concat(prefixCls, "-last-day-of-month");
      var month1 = value.clone();
      month1.date(1);
      var day = month1.day();
      var lastMonthDiffDay = (day + 7 - value.localeData().firstDayOfWeek()) % 7; // calculate last month

      var lastMonth1 = month1.clone();
      lastMonth1.add(0 - lastMonthDiffDay, 'days');
      var passed = 0;

      for (iIndex = 0; iIndex < DateConstants.DATE_ROW_COUNT; iIndex++) {
        for (jIndex = 0; jIndex < DateConstants.DATE_COL_COUNT; jIndex++) {
          current = lastMonth1;

          if (passed) {
            current = current.clone();
            current.add(passed, 'days');
          }

          dateTable.push(current);
          passed++;
        }
      }

      var tableHtml = [];
      passed = 0;

      for (iIndex = 0; iIndex < DateConstants.DATE_ROW_COUNT; iIndex++) {
        var _cx;

        var isCurrentWeek = void 0;
        var weekNumberCell = void 0;
        var isActiveWeek = false;
        var dateCells = [];

        if (showWeekNumber) {
          weekNumberCell = /*#__PURE__*/React.createElement("td", {
            key: dateTable[passed].week(),
            role: "gridcell",
            className: weekNumberCellClass
          }, dateTable[passed].week());
        }

        for (jIndex = 0; jIndex < DateConstants.DATE_COL_COUNT; jIndex++) {
          var next = null;
          var last = null;
          current = dateTable[passed];

          if (jIndex < DateConstants.DATE_COL_COUNT - 1) {
            next = dateTable[passed + 1];
          }

          if (jIndex > 0) {
            last = dateTable[passed - 1];
          }

          var cls = cellClass;
          var disabled = false;
          var selected = false;

          if (isSameDay(current, today)) {
            cls += " ".concat(todayClass);
            isCurrentWeek = true;
          }

          var _this$props = this.props,
              panelValue = _this$props.panelValue,
              noCurrentDate = _this$props.noCurrentDate;

          if (panelValue && !noCurrentDate && isSameDay(current, panelValue)) {
            cls += " ".concat(todayClass);
            isCurrentWeek = true;
          }

          var isBeforeCurrentMonthYear = beforeCurrentMonthYear(current, value);
          var isAfterCurrentMonthYear = afterCurrentMonthYear(current, value);

          if (selectedValue && Array.isArray(selectedValue)) {
            var rangeValue = hoverValue.length ? hoverValue : selectedValue;

            if (!isBeforeCurrentMonthYear && !isAfterCurrentMonthYear) {
              var startValue = rangeValue[0];
              var endValue = rangeValue[1];

              if (startValue) {
                if (isSameDay(current, startValue)) {
                  selected = true;
                  isActiveWeek = true;
                  cls += " ".concat(selectedStartDateClass);
                }
              }

              if (startValue && endValue) {
                if (isSameDay(current, endValue)) {
                  selected = true;
                  isActiveWeek = true;
                  cls += " ".concat(selectedEndDateClass);
                } else if (current.isAfter(startValue, 'day') && current.isBefore(endValue, 'day')) {
                  cls += " ".concat(inRangeClass);
                }
              }
            }
          } else if (isSameDay(current, value)) {
            // keyboard change value, highlight works
            selected = true;
            isActiveWeek = true;
          }

          if (isSameDay(current, selectedValue)) {
            cls += " ".concat(selectedDateClass);
          }

          if (isBeforeCurrentMonthYear) {
            cls += " ".concat(lastMonthDayClass);
          }

          if (isAfterCurrentMonthYear) {
            cls += " ".concat(nextMonthDayClass);
          }

          if (current.clone().endOf('month').date() === current.date()) {
            cls += " ".concat(lastDayOfMonthClass);
          }

          if (disabledDate) {
            if (disabledDate(current, value)) {
              disabled = true;

              if (!last || !disabledDate(last, value)) {
                cls += " ".concat(firstDisableClass);
              }

              if (!next || !disabledDate(next, value)) {
                cls += " ".concat(lastDisableClass);
              }
            }
          }

          if (selected) {
            cls += " ".concat(selectedClass);
          }

          if (disabled) {
            cls += " ".concat(disabledClass);
          }

          var dateHtml = void 0;

          if (dateRender) {
            dateHtml = dateRender(current, value);
          } else {
            var content = contentRender ? contentRender(current, value) : current.date();
            dateHtml = /*#__PURE__*/React.createElement("div", {
              key: getIdFromDate(current),
              className: dateClass,
              "aria-selected": selected,
              "aria-disabled": disabled
            }, content);
          }

          dateCells.push( /*#__PURE__*/React.createElement("td", {
            key: passed,
            onClick: disabled ? undefined : onSelect.bind(null, current),
            onMouseEnter: disabled ? undefined : props.onDayHover && props.onDayHover.bind(null, current) || undefined,
            role: "gridcell",
            title: getTitleString(current),
            className: cls
          }, dateHtml));
          passed++;
        }

        tableHtml.push( /*#__PURE__*/React.createElement("tr", {
          key: iIndex,
          role: "row",
          className: cx((_cx = {}, _defineProperty(_cx, "".concat(prefixCls, "-current-week"), isCurrentWeek), _defineProperty(_cx, "".concat(prefixCls, "-active-week"), isActiveWeek), _cx))
        }, weekNumberCell, dateCells));
      }

      return /*#__PURE__*/React.createElement("tbody", {
        className: "".concat(prefixCls, "-tbody")
      }, tableHtml);
    }
  }]);

  return DateTBody;
}(React.Component);

_defineProperty(DateTBody, "propTypes", {
  contentRender: PropTypes.func,
  dateRender: PropTypes.func,
  disabledDate: PropTypes.func,
  prefixCls: PropTypes.string,
  // selectedValue: PropTypes.oneOfType([PropTypes.object, PropTypes.arrayOf(PropTypes.object)]),
  selectedValue: PropTypes.any,
  value: PropTypes.object,
  hoverValue: PropTypes.any,
  showWeekNumber: PropTypes.bool
});

_defineProperty(DateTBody, "defaultProps", {
  hoverValue: []
});

export { DateTBody as default };


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-datepicker/src/rc-calendar/date/DateTBody.js